<!-- Hyperpure Iframe Overlay -->
<!-- Modal Backdrop -->
<div class="iframe-modal-backdrop"
    *ngIf="showIframe"
    (click)="closeIframe()"></div>

<!-- Iframe Panel -->
<div class="iframe-overlay"
    *ngIf="showIframe">
    <div class="iframe-header">
        <div class="d-flex align-items-center gap-2">
            <img src="assets/images/hyperpure_icon.svg"
                alt="Hyperpure Icon"
                style="height: 24px; width: 24px; background: red; border-radius: 4px; padding: 2px;"
                onerror="this.style.display='none'">
            <img src="assets/images/logo_hp.png"
                alt="Hyperpure"
                style="height: 24px;"
                onerror="this.style.display='none'">
            <span class="fw-semibold text-muted">Cart</span>
        </div>
        <div class="d-flex gap-2">
            <button class="iframe-control-btn"
                (click)="reloadIframe()"
                title="Refresh">
                <i class="material-icons">refresh</i>
            </button>
            <button class="iframe-control-btn close-btn"
                (click)="closeIframe()"
                title="Close">
                <i class="material-icons">close</i>
            </button>
        </div>
    </div>
    <div class="iframe-body">
        <iframe #iframeElement
            *ngIf="iframeUrlSafe"
            [src]="iframeUrlSafe"
            class="hyperpure-iframe"
            frameborder="0"
            loading="lazy"
            allow="payment; geolocation"></iframe>
    </div>
</div>